module.exports = "//static.hsappstatic.net/marketplace-assets-base/static-1.13667/img/templates-homepage/growth-analytics-icon.svg"